import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { ExtendedModuleState } from '../../../Shared/Frontend/application-discovery/module'
import { ModulePages, PagesRequirements } from './publicSite.module'
import { ModuleState, StateRequirements } from './publicSite.module.state'

export function publicSiteHeader<allApplicationState extends ModuleState & StateRequirements>(
  currentState: ExtendedModuleState<
    allApplicationState & ModuleState & StateRequirements,
    ModulePages & PagesRequirements
  >
): Widget<
  Updater<ExtendedModuleState<allApplicationState & ModuleState & StateRequirements, ModulePages & PagesRequirements>>
> {
  return fromJSX((_) => (
    <></>
  ))
}
